import React from 'react';
import { Grid, Col } from '@bit/knotchinc.web-react-components.grid';
import { EntityLogoTile } from 'components/Tiles/';

const InsightsBrandLogos = ({ metadata }) => {
  const entities = Object.values(metadata);
  /*
    This short circuit is needed so that StoreSync can properly render
    children w/o a ternary in ContentInsightTabs for this component
  */
  if (entities.length <= 1) return null;

  return (
    <Grid height={70}>
      {entities.map((entity) => (
        <Col key={`col-entity-logo-${entity.public_id}`} >
          <EntityLogoTile data={entity} />
        </Col>
        ))}
    </Grid>
  );
};

export default InsightsBrandLogos;
